<template>
    <div>
        <v-card flat>
            <v-card-text>
                <v-row v-if="title">
                    <v-col>
                        <h3 v-text="title" />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col class="pt-1 pb-1">
                        {{ $t('filter.title') }}
                        <v-chip v-for="item in filters" :key="item.key" closable filter small color="secondary" class="ma-1" @click:close="chipClosed(item.key)"
                            >{{ $t(item.nameResourceKey) }}: {{ item.value }}</v-chip
                        >
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
        <v-toolbar v-if="!downloadToolbar" density="compact" class="toolbar" flat color="white">
            <slot name="default" />
        </v-toolbar>
        <v-toolbar v-else density="compact" flat class="toolbar text-white" color="primary">
            <slot name="default" />
        </v-toolbar>
        <v-divider />
    </div>
</template>
<script lang="ts">
import { Component, Prop, Vue } from 'vue-facing-decorator';
import { TableHeaderFilterItem } from '@/types/TableHeaderFilterItem';

@Component({
    emits: ['chipClosed']
})
export default class TableHeader extends Vue {
    @Prop({ required: false, type: Array, default: () => [] })
    private filters!: Array<TableHeaderFilterItem>;

    @Prop({ required: false, type: String, default: null })
    private title!: string;

    @Prop({ required: false, type: Boolean, default: false })
    private downloadToolbar!: boolean;

    private chipClosed(value: string) {
        this.$emit('chipClosed', value);
    }
}
</script>
<style scoped>
.toolbar {
    padding-left: 15px;
}
.toolbar ::v-deep(.v-input) {
    margin-bottom: 20px !important;
}
</style>
